<template>
  <div class="body-mobile">
    <div class="wrapper-body">
      <div class="wrapper-body__header">
        <nav-step :active="1"></nav-step>
      </div>

      <div class="wrapper-body__body" v-if="!!form.student">
        <div class="wrapper-body__body__title">
          <p v-if="studentType===1">填写信息<span>（1/5）</span></p>
          <p v-else>填写信息<span>（1/4）</span></p>
        </div>
        <div class="wrapper-body__body__container" v-if="form">
          <p class="upload-item-label"><span class="text-error">*</span>上传幼儿照片</p>
          <div>
            <upfile-image v-model="cover_img_1" acceptType="image/*" imageType="image/jpg, image/jpeg, image/png, image/bmp" :file-size-in-k-b="10000" :handle-success="onUpimageSuccess1" :handle-error="imgOnErr1"/>
          </div>
          <p class="upload-item-label"><span class="text-error">*</span>上传户口簿首页</p>
          <div>
            <upfile-image v-model="cover_img_2" acceptType="image/*" imageType="image/jpg, image/jpeg, image/png, image/bmp" :file-size-in-k-b="10000" :handle-success="onUpimageSuccess2" :handle-error="imgOnErr2"/>
          </div>
          <p class="upload-item-label"><span class="text-error">*</span>附加图片（选择一项：户口簿幼儿页、拆迁安置协议、房屋租赁备案凭证、房产证明、购房合同）</p>
          <div>
            <upfile-image v-model="cover_img_3" acceptType="image/*" imageType="image/jpg, image/jpeg, image/png, image/bmp" :file-size-in-k-b="10000" :handle-success="onUpimageSuccess3" :handle-error="imgOnErr3"/>
          </div>
        </div>
      </div>
      <div class="wrapper-body__footer">
        <div class="box-btns">
          <span class="button-primary" @touchstart="handlePreviousStep">上一步</span>
          <span class="button-primary-inset"
                @touchstart="handleNextStep">下一步</span>
        </div>
        <!-- <div><router-link :to="{path: 'bm_login', query: {signupNoticeId: $route.query.signupNoticeId}}">同意并遵守</router-link></div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageForm from '../index/mixins/page_bm_form';
  import UpfileImage from '../../../sxui/components/upload/UpfileImage';

  export default {
    mixins: [IndexCommon, MobileCommon, PageForm],
    components: { UpfileImage },
    data() {
      return {
        cover_img_1: '',
        cover_img_2: '',
        cover_img_3: ''
      }
    },
    mounted() {
      // window.step1 = this;
      // 1. 更新formData
      this.updateFormData();
			console.log('[-> Step1] Form ::', this.form);
			let { photo, homePage, studentPage } = this.form.student;

			if (photo) {
				this.cover_img_1 = photo;
			}

			if (homePage) {
				this.cover_img_2 = homePage;
			}

			if (studentPage) {
				this.cover_img_3 = studentPage;
			}

      // 2. 转换formData中的某些字段到当前视图中
      // todo
    },
    methods: {
      onUpimageSuccess1(data) {
				console.log('-> 上传幼儿照片成功', data);
				this.form.student.photo = data[0].__remoteUrl;
      },
      onUpimageSuccess2(data) {
				console.log('-> 上传户口簿首页成功', data);
				this.form.student.homePage = data[0].__remoteUrl;
      },
      onUpimageSuccess3(data) {
				console.log('-> 上传户口簿幼儿页成功', data);
				this.form.student.studentPage = data[0].__remoteUrl;
      },
      imgOnErr1() {
				this.cover_img_1 = '';
				this.form.student.photo = '';
      },
      imgOnErr2() {
				this.cover_img_2 = '';
				this.form.student.homePage = '';
      },
      imgOnErr3() {
				this.cover_img_3 = '';
				this.form.student.studentPage = '';
      },
      handleNextStep() {
				let { form, $message } = this;
				let { photo, homePage, studentPage } = form.student;

        // 1.验证参数
				if (!photo || !homePage || !studentPage) {
					return this.$message.error('存在未上传的材料！');
				}

        // 2.转换formData格式，使数据格式和后端的保持一致（需要的才处理）
        // form[xxx] = xxx;

        // 3.保存formData到sessionStorage中
        this.saveFormData(form);

        // 4.跳转路由
        this.$router.push({
          path: './step2_student_info',
          query: this.$route.query
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
	.body-mobile
		.wrapper-body
			.wrapper-body__body__container
				padding 0.1rem .6rem .2rem
				.upload-item-label
					font-size .32rem
					margin .2rem 0
		>>> .ant-upload.ant-upload-select-picture-card
			width 3rem
			svg
				width 2rem
				height 1rem
</style>
